/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductCarousel_item = {
    readonly serviceId: string | null;
    readonly carouselPhotos: ReadonlyArray<{
        readonly __typename: string;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
    readonly " $refType": "ProductCarousel_item";
};
export type ProductCarousel_item$data = ProductCarousel_item;
export type ProductCarousel_item$key = {
    readonly " $data"?: ProductCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductCarousel_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 2,
      "kind": "LocalArgument",
      "name": "photosLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "carouselPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "photosLimit",
          "variableName": "photosLimit"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductSwiper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '47bb1a3acac5e40f978f302e8b884c05';
export default node;
